/**
 * ListingsPage: the user's own bounty listings, rendered at /account/listings
 * (nested under UserHomepage). Pure composition, no local state or API calls:
 * two components/SubheadedPage sections ("active listings" and "completed
 * listings"), each rendering a components/ItemCollection of type "user-listings"
 * filtered by statusType ("active" / "completed"). Data fetching happens inside
 * ItemCollection.
 */
import { SubheadedPage } from "@/components/SubheadedPage";
import ItemCollection from "@/components/ItemCollection";

const ListingsPage = () => {
    return (
        <div className="flex flex-col w-full pb-16">
            <SubheadedPage heading="active listings">
                <ItemCollection
                    type="user-listings"
                    itemType="bounty"
                    statusType="active"
                    format="row"
                    emptyStateText="no active listings"
                />
            </SubheadedPage>
            <SubheadedPage heading="completed listings">
                <ItemCollection
                    type="user-listings"
                    itemType="bounty"
                    statusType="completed"
                    format="row"
                    emptyStateText="no completed listings"
                />
            </SubheadedPage>
        </div>
    );
};

export default ListingsPage;
